import React from "react";
import Table from "../../ui/Table/Table";
import classnames from "classnames";
import "./CategoryTable.scss";
import useSort from "../../hooks/useSort";

import spaceint2 from "../../utils/spaceint2";
import useGlobals from "../../hooks/useGlobals";

const columns = [
  {
    title: "Категории",
    accessor: "name",
    clssName: "table__border-right category-table__name-col",
    dataClssName: "table__border-right",
    renderDataCell: ({ data }) => <a href="http://ya.ru">{data.name}</a>
  },
  {
    title: "Анонсы  (актив/норм)",
    accessor: "cnt",
    className: "category-table__cnt-col",
    dataClassName: "table__border-right",
    renderDataCell: ({ data }) => (
      <span
        className={classnames({
          "category-table__red-cell": data.active_cnt_warn
        })}
      >
        {spaceint2(data.cnt)} / {spaceint2(data.active_cnt_norm)}
      </span>
    )
  },
  {
    title: "Не установлен",
    accessor: "mpaa_rating_not_set_cnt",
    className: "category-table__not-set",
    dataClassName: "table__border-right",
    renderDataCell: ({ data }) => data.mpaa_rating_not_set_cnt
  },
  {
    title: "G",
    accessor: "mpaa_rating_g_cnt",
    className: "category-table__g",
    dataClassName: "table__border-right",
    renderDataCell: ({ data }) => data.mpaa_rating_g_cnt
  },
  {
    title: "PG",
    accessor: "mpaa_rating_pg_cnt",
    className: "category-table__pg",
    dataClassName: "table__border-right",
    renderDataCell: ({ data }) => data.mpaa_rating_pg_cnt
  },
  {
    title: "PG-13",
    accessor: "mpaa_rating_pg_13_cnt",
    className: "category-table__pg-13",
    dataClassName: "table__border-right",
    renderDataCell: ({ data }) => data.mpaa_rating_pg_13_cnt
  },
  {
    title: "R",
    accessor: "mpaa_rating_r_cnt",
    className: "category-table__r",
    dataClassName: "table__border-right",
    renderDataCell: ({ data }) => data.mpaa_rating_r_cnt
  },
  {
    title: "NC-17",
    accessor: "mpaa_rating_nc_17_cnt",
    className: "category-table__nc-17",
    dataClassName: "table__border-right",
    renderDataCell: ({ data }) => data.mpaa_rating_nc_17_cnt
  }
];

const summary = {};
const summaryColumns = [];

const CategoryTable = ({ categories, loading }) => {
  const globals = useGlobals();
  const { sortBy, sortOrder, onSortChange } = useSort("name", "asc");

  const data = categories.map(row => {
    const result = {
      ...row,
      mpaa_rating_not_set_cnt: row.mpaa_cnt[""]
    };

    globals.mpaa_rating.forEach(item => {
      result[`mpaa_rating_${item.name.toLowerCase().replace("-", "_")}_cnt`] =
        row.mpaa_cnt[item.id];
    });

    return result;
  });

  return (
    <div className="category-table">
      <Table
        columns={columns}
        data={data}
        summaryColumns={summaryColumns}
        summary={summary}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSortChange={onSortChange}
        loading={loading}
      />
    </div>
  );
};

export default CategoryTable;
